import Component from 'inferno-component';

class DeleteDeckModal extends Component {
  render() {
    const { deck, deleteSelectedDeck, toggleDeleteDeckModal } = this.props;
    return (
      <div className="flashcard-modal">
        <div className="flashcard-modal--container">
          <div className="delete-modal">
            <h2>Are you sure you want to delete this deck?</h2>
            <h3>{deck.deckName}</h3>
            <div className="delete-button">
              <button
                className="button"
                onClick={() => {
                  deleteSelectedDeck(deck.deckId);
                }}
              >
                Yes, delete this deck
              </button>
            </div>
            <div className="cancel">
              <button onClick={toggleDeleteDeckModal}>Cancel</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DeleteDeckModal;



// WEBPACK FOOTER //
// ./src/components/DeleteDeckModal.js